import { useEffect, useState } from '@biletiniz/ui-core';
import { useMutation } from '@biletiniz/apollo';
import { CONFIRM } from './gql/confirm';

export const useConfirm = () => {
    const [localData, setLocalData] = useState(false);

    const [useConfirmMutation, { error, loading }] = useMutation(CONFIRM, {
        onCompleted: setLocalData,
    });
    const [loaded, setLoaded] = useState(false);
    const confirm = confirmInfo => {
        return useConfirmMutation({
            variables: confirmInfo,
        });
    };
    useEffect(() => {
        if (localData && !loaded) {
            setLoaded(true);
        }
    }, [localData]);

    const initialValues = {
        confirm: '',
    };

    return {
        localData,
        setLocalData,
        loaded,
        error: error?.message,
        confirm,
        loading,
        initialValues,
    };
};
